import { Component, Vue } from 'vue-property-decorator';
import SettingService from '@/modules/services/setting.service';

const settingService = new SettingService();

@Component
export default class UserSecurity extends Vue {
	public UserList: [] = [];
	public chkbox: any = '';
	public successMessage = '';
	public otp_token = '';
	public chk_box:boolean = false;

	public created() {
		$(document).prop('title', 'Dshop User Security')
		this.getUserSecurity();
	}

	private getUserSecurity() {
		this.UserList = [];
		this.$store.state.Loading = true;
		settingService.UserList().then((res: any) => {
			this.$store.state.Loading = false;
			if (res.data.data.status === true) {
				this.UserList = res.data.data.user_list;

			}
		}, (err: any) => {
			this.$store.state.Loading = false;
			this.$store.dispatch('showErrorMsg', err.message);
		})
	}

	private RestMfaButtonClick(username: any, id: any, otp_status: any) {
		const request = { user_id: id };
		settingService.deleteMfaById({ data: request }).then((res: any) => {
			const response = res.data.data;
			if (response.status) {
				this.$store.dispatch('showSuccessMsg', response.message);
			} else {
				this.$store.dispatch('showErrorMsg', response.message);
			}
		}, (err: any) => {
			this.$store.dispatch('showErrorMsg', err.message);
		})
	}

	private DisableMfaUser(username: any, id: any, otp_status: any) {
		console.log("Dsiable MFA for " + username + " with id " + id)
		const request = { user_id: id };
		this.$store.state.Loading = true;
		settingService.disableMfaById({ data: request }).then((res: any) => {
			const response = res.data.data;
			if (response.status) {

				this.otp_token = "token" + id;
				this.$cookies.remove(this.otp_token)
				setTimeout(()=>{
					this.getUserSecurity();
					this.$store.state.Loading = false;
					this.$store.dispatch('showSuccessMsg', response.message);
				},1000)
			} else {
				this.$store.state.Loading = false;
				this.$store.dispatch('showErrorMsg', response.message);
			}
		}, (err: any) => {
			this.$store.state.Loading = false;
			this.$store.dispatch('showErrorMsg', err.message);
		})
	}

	private EnableMfaUser(username: any, id: any, otp_status: any) {
		console.log("Enable MFA for " + username + " with id " + id)
		const request = { user_id: id };
		this.$store.state.Loading = true;
		settingService.enableMfaById({ data: request }).then((res: any) => {
			const response = res.data.data;
			if (response.status) {
				setTimeout(()=>{
					this.getUserSecurity();
					this.$store.state.Loading = false;
					this.$store.dispatch('showSuccessMsg', response.message);
				},1000)
			} else {
				this.$store.state.Loading = false;
				this.$store.dispatch('showErrorMsg', response.message);
			}
		}, (err: any) => {
			this.$store.state.Loading = false;
			this.$store.dispatch('showErrorMsg', err.message);
		})
	}


}
